import * as React from "react";

type Props = {
  steps: number;
  currentStep: number;
  color?: string;
  progressColor?: string;
};

const StepsIndicator = ({
  steps,
  currentStep,
  color = "#DEE1EB",
  progressColor = "#FE8E23",
}: Props) => {
  return (
    <div className='flex justify-center gap-5 flex-nowrap'>
      {Array(steps)
        .fill(0)
        .map((_i, k) => (
          <div
            key={k}
            style={{ backgroundColor: currentStep - 1 >= k ? progressColor : color }}
            className='h-1 lg:h-2 w-32 rounded-xl'
          />
        ))}
    </div>
  );
};

export default StepsIndicator;
